import { SentryError } from '@ifixit/sentry';
import type { ReactNode } from 'react';
import type { EditorPreset } from '.';
import { CommentsMenuBar } from './comments';
import { GuideIntroMenuBar } from './guide_intro';
import { AnswersMenuBar } from './answers';
import { WikiMenuBar } from './wiki';
import { useEditorContext } from '../editor_context';

export const MenuBar = (props: { preset: EditorPreset; menubarEnd?: ReactNode }) => {
   const { preset, menubarEnd } = props;
   const { editor } = useEditorContext();

   if (!editor) {
      return null;
   }

   switch (preset) {
      case 'comments': {
         return <CommentsMenuBar />;
      }
      case 'guide_intro': {
         return <GuideIntroMenuBar menubarEnd={menubarEnd} />;
      }
      case 'answers': {
         return <AnswersMenuBar />;
      }
      case 'wiki': {
         return <WikiMenuBar />;
      }
      default: {
         throw new SentryError(`Invalid preset: ${preset}`);
      }
   }
};
